import {useEffect} from 'react';

/** Keep the top banner attached to the viewport during downward edge gestures. */
export function MobileBannerScroll(){
 useEffect(()=>{
  const mobile=matchMedia('(max-width:640px)');
  let x=0,y=0,tracking=false;
  function start(event:TouchEvent){
   tracking=event.touches.length===1;
   if(tracking){x=event.touches[0].clientX;y=event.touches[0].clientY}
  }
  function move(event:TouchEvent){
   if(!tracking||event.touches.length!==1)return;
   const touch=event.touches[0],dx=touch.clientX-x,dy=touch.clientY-y;x=touch.clientX;y=touch.clientY;
   if(!mobile.matches||dy<=Math.abs(dx)||window.scrollY>0||(window.visualViewport?.scale||1)>1)return;
   const target=event.target instanceof Element?event.target:null;
   if(!target?.closest('#main-content')||target.closest('dialog,[role="dialog"],.robot-pet,input,textarea,select,[contenteditable="true"]'))return;
   // Nested scroll areas (filters, carousels and menus) keep their own gestures.
   for(let node:Element|null=target;node&&node!==document.body;node=node.parentElement){
    const style=getComputedStyle(node);
    if(/auto|scroll/.test(style.overflowY)&&node.scrollHeight>node.clientHeight+1)return;
   }
   if(event.cancelable)event.preventDefault();
  }
  function end(){tracking=false}
  document.addEventListener('touchstart',start,{passive:true});
  document.addEventListener('touchmove',move,{passive:false});
  document.addEventListener('touchend',end,{passive:true});
  document.addEventListener('touchcancel',end,{passive:true});
  return()=>{document.removeEventListener('touchstart',start);document.removeEventListener('touchmove',move);document.removeEventListener('touchend',end);document.removeEventListener('touchcancel',end)};
 },[]);
 return null;
}
